import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, InputAdornment, TextField, Typography } from "@mui/material";

export const RTFOPadParameters = ({ wells, settings, setSettings }) => {
  try {

    return (
      <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
  
        <div style={{marginTop: 30, marginBottom: 20}}>
          <Typography color='primary'>FRICTION MODEL</Typography>
          {/* <Typography color='textSecondary'>FRICTION MODEL</Typography> */}
          
          {wells?.map(well => {
            return (
              <Accordion 
                disableGutters={false}
                key={well.name}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography noWrap>{well?.name?.charAt(0)?.toUpperCase()?.concat(well?.name?.substr(1, )) || ""}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {
                    ['casing1', 'casing2'].map(casing => {
                      return (
                        <Accordion key={casing}>
                          <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography fontSize="16px" variant="h6">{formatCasingName(casing)}</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 20}}>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18.2%'}}>
                              <Typography fontSize="14px">OD</Typography>
                              <TextField
                                margin="dense"
                                size="small"
                                value={settings?.wells?.[well.name]?.[casing]?.od}
                                variant="outlined"
                                onChange={e => handleParameterChange('od', e.target.value, well?.name, casing)}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">mm</InputAdornment>
                                }}
                                type="number"
                                inputProps={{
                                  step: 0.1
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18.2%'}}>
                              <Typography fontSize="14px">ID</Typography>
                              <TextField
                                margin="dense"
                                size="small"
                                value={settings?.wells?.[well.name]?.[casing]?.id}
                                variant="outlined"
                                onChange={e => handleParameterChange('id', e.target.value, well?.name, casing)}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">mm</InputAdornment>
                                }}
                                type="number"
                                inputProps={{
                                  step: 0.1
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18.2%'}}>
                              <Typography fontSize="14px">Measured Depth</Typography>
                              <TextField
                                margin="dense"
                                size="small"
                                value={settings?.wells?.[well.name]?.[casing]?.md}
                                variant="outlined"
                                onChange={e => handleParameterChange('md', e.target.value, well?.name, casing)}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">m</InputAdornment>
                                }}
                                type="number"
                                inputProps={{
                                  step: 0.1
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18.2%'}}>
                              <Typography fontSize="14px">Friction Coefficient</Typography>
                              <TextField
                                margin="dense"
                                size="small"
                                value={settings?.wells?.[well.name]?.[casing]?.fc}
                                variant="outlined"
                                onChange={e => handleParameterChange('fc', e.target.value, well?.name, casing)}
                                type="number"
                                inputProps={{
                                  step: 0.0001
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18.2%'}}>
                              <Typography fontSize="14px">PL Exponent</Typography>
                              <TextField
                                margin="dense"
                                size="small"
                                value={settings?.wells?.[well.name]?.[casing]?.plExp}
                                variant="outlined"
                                onChange={e => handleParameterChange('plExp', e.target.value, well?.name, casing)}
                                type="number"
                                inputProps={{
                                  step: 0.0001
                                }}
                                fullWidth
                              />
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  }
                </AccordionDetails>
              </Accordion>
            )
          })}
        </div>

        <div style={{marginTop: 20, marginBottom: 20, width: '100%'}}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Typography color='primary' style={{marginRight: 10}}>FRAC MODEL</Typography>
            <AdvancedTag />
          </div>
          
          <div style={{display: 'flex', flexDirection: 'column', marginTop: 5}}>
            
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 20}}>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '22.5%'}}>
                <Typography fontSize="14px">Frac Height</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.fracHeight}
                  variant="outlined"
                  onChange={e => handleParameterChange('fracHeight', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">m</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 1
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '22.5%'}}>
                <Typography fontSize="14px">Frac Orientation</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.fracAngle}
                  variant="outlined"
                  onChange={e => handleParameterChange('fracAngle', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">deg</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 1
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '22.5%'}}>
                <Typography fontSize="14px">Matrix Permeability</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.k}
                  variant="outlined"
                  onChange={e => handleParameterChange('k', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">md</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 0.0001
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '22.5%'}}>
                <Typography fontSize="14px">Matrix Porosity</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={Math.round((settings?.phi * 100 + Number.EPSILON) * 100) / 100}
                  variant="outlined"
                  onChange={e => handleParameterChange('phi', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 0.01
                  }}
                  fullWidth
                />
              </div>
            </div>


            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 20}}>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '30%'}}>
                <Typography fontSize="14px">Total Compressibility</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.cT}
                  // value={Number.parseFloat(settings?.cT)?.toExponential()}
                  variant="outlined"
                  onChange={e => handleParameterChange('cT', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">1/psi</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 0.0000001
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '30%'}}>
                <Typography fontSize="14px">Water Viscosity</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.muW}
                  variant="outlined"
                  onChange={e => handleParameterChange('muW', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">cP</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 0.0001
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '30%'}}>
                <Typography fontSize="14px">Water FVF</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.bW}
                  variant="outlined"
                  onChange={e => handleParameterChange('bW', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">bbl/stb</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 0.001
                  }}
                  fullWidth
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{marginBottom: 20, width: '100%'}}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Typography color='primary' style={{marginRight: 10}}>FRAC MODEL</Typography>
            <SimplifiedTag />
          </div>
          
          <div style={{display: 'flex', flexDirection: 'column', marginTop: 5}}>
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18%'}}>
                <Typography fontSize="14px">Closure Gradient</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.closureGradient}
                  variant="outlined"
                  onChange={e => handleParameterChange('closureGradient', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">psi/ft</InputAdornment>
                  }}
                  type="number"
                  inputProps={{
                    step: 0.01
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18%'}}>
                <Typography fontSize="14px">Poisson's Ratio</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.poissonRatio}
                  variant="outlined"
                  onChange={e => handleParameterChange('poissonRatio', e.target.value)}
                  type="number"
                  inputProps={{
                    step: 0.01
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18%'}}>
                <Typography fontSize="14px">WCC</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.wcc}
                  variant="outlined"
                  onChange={e => handleParameterChange('wcc', e.target.value)}
                  type="number"
                  inputProps={{
                    step: 0.01
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18%'}}>
                <Typography fontSize="14px">Fluid Efficiency</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.fluidEfficiency}
                  variant="outlined"
                  onChange={e => handleParameterChange('fluidEfficiency', e.target.value)}
                  type="number"
                  inputProps={{
                    step: 0.01
                  }}
                  fullWidth
                />
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '18%'}}>
                <Typography fontSize="14px">Alpha</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  value={settings?.alpha}
                  variant="outlined"
                  onChange={e => handleParameterChange('alpha', e.target.value)}
                  type="number"
                  inputProps={{
                    step: 0.1
                  }}
                  fullWidth
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{marginTop: 30, marginBottom: 20, width: '100%'}}>
          <Typography color='primary'>STRESS SHADOW</Typography>
          {/* <Typography color='textSecondary'>STRESS SHADOW</Typography> */}
          
          <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 5}}>

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '30%'}}>
              <Typography fontSize="14px" style={{marginRight: 20}}>Young's Modulus</Typography>
              <TextField
                margin="dense"
                size="small"
                value={settings?.youngModulus}
                // value={Number.parseFloat(settings?.youngModulus)?.toExponential()}
                variant="outlined"
                onChange={e => handleParameterChange('youngModulus', e.target.value)}
                fullWidth
                InputProps={{
                  endAdornment: <InputAdornment position="end">psi</InputAdornment>
                }}
                type="number"
                inputProps={{
                  step: 100
                }}
              />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '30%'}}>
              <Typography fontSize="14px" style={{marginRight: 20}}>Frac Width</Typography>
              <TextField
                margin="dense"
                size="small"
                value={settings?.fracWidth}
                variant="outlined"
                onChange={e => handleParameterChange('fracWidth', e.target.value)}
                InputProps={{
                  endAdornment: <InputAdornment position="end">in</InputAdornment>
                }}
                type="number"
                inputProps={{
                  step: 0.01
                }}
                fullWidth
              />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '30%'}}>
              <Typography fontSize="14px" style={{marginRight: 20}}>Transverse Exponent</Typography>
              <TextField
                margin="dense"
                size="small"
                value={settings?.t}
                variant="outlined"
                onChange={e => handleParameterChange('t', e.target.value)}
                type="number"
                inputProps={{
                  step: 0.1
                }}
                fullWidth
              />
            </div>
          </div>
        </div>

      </div>
    );
  } catch (error) {
    console.log(error);
    return <></>;
  };

  function handleParameterChange(parameter, value, wellName, casingName) {
    if (parameter === 'od' || parameter === 'id' || parameter === 'md' || parameter === 'fc' || parameter === 'plExp') {

      const newSettings = JSON.parse(JSON.stringify(settings));
      newSettings.wells[wellName][casingName][parameter] = parseFloat(value);
      setSettings(() => newSettings);

    } else {
      if (parameter === 'phi') {
        setSettings(prev => {
          return {...prev, [parameter]: parseFloat(value) / 100};
        });
      } else {
        setSettings(prev => {
          return {...prev, [parameter]: parseFloat(value)};
        });
      };
    };
  };

  function formatCasingName(casing) {
    if (casing === 'casing1') {
      return 'Casing 1';
    } else if (casing === 'casing2') {
      return 'Casing 2';
    } else {
      return '';
    };
  };

};

function AdvancedTag() {
  return (
    <div style={{width: 64, height: 16, borderRadius: '8px', outline: '1px solid #0758B7', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, margin: 0}}>
      <Typography style={{fontSize: 10, fontWeight: 'bold', color: '#0758B7'}}>ADVANCED</Typography>
    </div>
  );
};

function SimplifiedTag() {
  return (
    <div style={{width: 64, height: 16, borderRadius: '8px', outline: '1px solid #0758B7', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0, margin: 0}}>
      <Typography style={{fontSize: 10, fontWeight: 'bold', color: '#0758B7'}}>SIMPLIFIED</Typography>
    </div>
  );
};